import { api } from "@/shared/libs/axiosClient";
import type {
  CollectionSizeResponse,
  CollectionsSizeSearchParams,
} from "@/types/collection-types";

/**
 * 수집 데이터 크기 검색
 */
export async function searchCollectionSizes(
  params: CollectionsSizeSearchParams
): Promise<CollectionSizeResponse> {
  return api.post<CollectionSizeResponse>("/collection-sizes/search", {
    start_date: params.start_date,
    end_date: params.end_date,
    dw_account_id: params.dw_account_id || undefined,
    channel: params.channel || undefined,
    report_type: params.report_type || undefined,
    page: params.page || 1,
    page_size: params.page_size || 50,
    order_by: params.order_by || "row_count",
    is_desc: params.is_desc !== undefined ? params.is_desc : true,
  });
}
